interface DisposableWasmHandle {
  free(): void;
}

interface CachedProgram<T extends DisposableWasmHandle> {
  signature: string;
  handle: T;
}

/** Session-local cache for compiled WASM graph programs.
 * Replacing or clearing an entry always releases its native handle. */
export class WasmProgramCache<T extends DisposableWasmHandle> {
  private readonly entries = new Map<string, CachedProgram<T>>();

  get(graphId: string, definition: unknown, compile: () => T): T {
    const signature = JSON.stringify(definition);
    const cached = this.entries.get(graphId);
    if (cached?.signature === signature) return cached.handle;
    if (cached) {
      cached.handle.free();
      this.entries.delete(graphId);
    }
    const handle = compile();
    this.entries.set(graphId, { signature, handle });
    return handle;
  }

  clear(): void {
    for (const cached of this.entries.values()) cached.handle.free();
    this.entries.clear();
  }
}
